/**
 * Haptic feedback utility for mobile devices
 * Uses the Vibration API when available
 */

/**
 * Trigger haptic feedback
 * @param {number|number[]} pattern - Vibration pattern (ms duration or array of [vibrate, pause, vibrate, ...])
 */
export function haptic(pattern = 10) {
  if (typeof window === 'undefined') return;
  
  // Check if Vibration API is available (mobile browsers)
  if ('vibrate' in navigator) {
    try {
      navigator.vibrate(pattern);
    } catch (error) {
      // Silently fail if vibration is not supported or blocked
      console.debug('Haptic feedback not available:', error);
    }
  }
}

/**
 * Light haptic feedback (short tap)
 */
export function hapticLight() {
  haptic(10);
}

/**
 * Medium haptic feedback (standard button press)
 */
export function hapticMedium() {
  haptic(20);
}

/**
 * Strong haptic feedback (important action)
 */
export function hapticStrong() {
  haptic(30);
}

/**
 * Success haptic pattern (double tap)
 */
export function hapticSuccess() {
  haptic([20, 50, 20]);
}

/**
 * Error haptic pattern (triple tap)
 */
export function hapticError() {
  haptic([10, 50, 10, 50, 10]);
}

/**
 * Selection haptic (for toggles, switches)
 */
export function hapticSelection() {
  haptic(15);
}

